<vo-header>
  <vo-header-navigation></vo-header-navigation>
  <a vo-anchor image voHeaderLogo href="https://www.virginmedia.com">
    <img [ngSrc]="headerLogo.logoAsset" [alt]="headerLogo.logoAlt" width="69" height="40" />
  </a>
  <button *ngIf="isAuthenticated" vo-header-icon icon="FarLock" title="Logout" [voConnectedOverlay]="overlay"></button>
  <button *ngIf="!isAuthenticated" vo-header-icon icon="FarUser" title="Login" [voConnectedOverlay]="overlay"></button>
</vo-header>
<vo-header-decoration [variant]="'secondary'"></vo-header-decoration>

<vo-connected-overlay #overlay label="Open menu">
  <!-- Drop down user -->
  <ul vo-list noMarker="true" *ngIf="loginContent$ | async as pageContent">
    <li vo-text *ngIf="!isAuthenticated">
      <div class="my__account__item">
        <button vo-anchor color="inherit" noDecoration (click)="onLoginClick()">
          {{ pageContent.buttons[0].label }}
          <vo-icon icon="FasChevronRight" size="md" />
        </button>
      </div>
    </li>
    <li vo-text *ngIf="!isAuthenticated">
      <div class="my__account__item">
        <a vo-anchor color="inherit" noDecoration href="{{ pageContent.buttons[1].url }}">
          {{ pageContent.buttons[1].label }}
          <vo-icon icon="FasChevronRight" size="md" />
        </a>
      </div>
    </li>
    <li vo-text *ngIf="!isAuthenticated">
      <div class="my__account__item">
        <a vo-anchor color="inherit" noDecoration href="{{ pageContent.buttons[2].url }}">
          {{ pageContent.buttons[2].label }}
          <vo-icon icon="FasChevronRight" size="md" />
        </a>
      </div>
    </li>
    <li vo-text *ngIf="isAuthenticated">
      <div class="my__account__item">
        <button vo-anchor color="inherit" noDecoration (click)="onLogoutClick()">
          {{ pageContent.buttons[3].label }}
          <vo-icon icon="FasChevronRight" size="md" />
        </button>
      </div>
    </li>
  </ul>
</vo-connected-overlay>
